/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * SELF — taken by the person on the screen of the test, opened with its key; EXAMINED — a practical exam an examiner ran from the panel and marked.
 * @export
 * @enum {string}
 */

export const AttemptModeDto = {
    Self: 'SELF',
    Examined: 'EXAMINED'
} as const;

export type AttemptModeDto = typeof AttemptModeDto[keyof typeof AttemptModeDto];



